import { Injectable } from '@angular/core';
import { UserAgentService } from '@shared/services/user-agent.service';

@Injectable({ providedIn: 'root' })
export class BrowserSupportedCapabilitiesService {
  constructor(private userAgentService: UserAgentService) {}

  isVoiceRecognitionAllowed(): boolean {
    return this.userAgentService.isSafari() || this.userAgentService.isChrome();
  }

  isScreenshotAllowed(): boolean {
    return !this.userAgentService.isHandheld();
  }

  isHighlightAllowed(): boolean {
    return !this.userAgentService.isHandheld();
  }

  isPasskeyAvailable(): boolean {
    return 'PublicKeyCredential' in window && !!navigator?.credentials;
  }
}
